import React from "react";
import Text from "../typography/Text";

export default ({ tags = [], max = 100 }) => {
  const filteredTags = filterUniq(tags);
  return (
    <div className="tags">
      {filteredTags.slice(0, max).map((tag, index) => (
        <span className={`tags_tag`} key={index}>
          {tag}
        </span>
      ))}
      {filteredTags.length > max && (
        <Text superSmall>+{filteredTags.length - max}</Text>
      )}
    </div>
  );
};

const filterUniq = (tags = []) =>
  tags.filter((tag, index, array) => {
    return array.findIndex(item => item === tag) === index;
  });
